import { NICmsContentComponent } from '@icms/core/content';

export const BLOG_TAB = 'Blog';

export namespace NCmsBlogRoot {
    export const typeId = 'blog-root';

    export interface ITypeData {
        /**
         * If true then tag will redirect location
         * otherwise they will act as a filter without changes
         */
        tagRedirect: string;
        components: NICmsContentComponent.IData[];
    }
}
